export default __webpack_public_path__ + "static/Druid-f9cc978e601912e43b4f3c59ee818d58.png";